<!-- Template input-->
<ng-content></ng-content>

<!-- State 1: Search address -->
@if (!isAddressSelected() || clearSelected()) {
  <div class="flex justify-start content-center items-center">
    @if (manualInput === false) {
      <mat-form-field [appearance]="appearance()" [ngClass]="{ 'invalid': showValidationError() }" [class]="class() + ' address-material-input-' + appearance()" class="basis-4/5">
        @if (appearance() !== 'none') {
          <mat-label translate="">Search for address</mat-label>
        }
        <input matInput="" [placeholder]="appearance() === 'none' ? '...' : ''" #searchBox="" type="text" value="{{getAddressLabel()}}" [matAutocomplete]="auto" autocomplete="off" (keyup)="$event.key !== 'Enter' ? searchTerm.next($event.target.value) : searchTerm">
        <div matSuffix="" class="flex items-center">
          @if (loading) {
            <mat-spinner class="px2" [diameter]="appearance() === 'outline' ? 24 : 16"></mat-spinner>
          } @else if (!manualInput && !disableManualEnter()) {
            <button type="button" mat-icon-button="" (click)="changeManualInput()">
              <mat-icon class="icon-small">search_off</mat-icon>
            </button>
          }
        </div>
      </mat-form-field>
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="optionSelected($event)" [displayWith]="renderPossibleAddress">
        @if (searched && !loading && possibleAddresses.length === 0) {
          <mat-option>
            <div class="flex justify-start content-center items-center flex-row">
              <span class="main black" (click)="changeManualInput(true)">
                @if (!disableManualEnter()) {
                  <span translate="">Nothing found, click to enter details manually</span>
                }
                @if (disableManualEnter()) {
                  <span translate="">Nothing found</span>
                }
              </span>
            </div>
          </mat-option>
        }
        @for (address of possibleAddresses; track address) {
          <mat-option [value]="address">
            <div>{{ renderPossibleAddress(address) }}</div>
          </mat-option>
        }
      </mat-autocomplete>
    }
  </div>
}

<!-- State 2: Address selected -->
@if (isAddressSelected() && !clearSelected() && appearance() !== 'outline') {
  <div>
    <span class="good flex justify-start content-center items-center flex-row flex-initial">
      <!-- <mat-icon class="icon-small mr1">place</mat-icon> -->
      <span>{{getAddressLabel()}}</span>
      <mat-icon class="icon-small" (click)="clearAddress()">clear</mat-icon>
    </span>
  </div>
}

@if (isAddressSelected() && !clearSelected() && appearance() === 'outline') {
  <div class="flex justify-start content-center items-center flex-row">
    <mat-form-field [appearance]="appearance()" [class]="class()" class="basis-4/5">
      <mat-label translate="">Address</mat-label>
      <input matInput="" type="text" value="{{getAddressLabel()}}" readonly="">
      <button mat-icon-button="" matSuffix="" (click)="clearAddress()">
        <mat-icon class="icon-small">clear</mat-icon>
      </button>
    </mat-form-field>
  </div>
}


<!-- State 3: Manual input -->
@if (manualInput === true && !isAddressSelected()) {
  <div [formGroup]="addressGroup">
    <div class="flex gap-[0.75rem]">
      <mat-form-field [appearance]="appearance()" [class]="class()" class="basis-3/5">
        <mat-label translate="">Street</mat-label>
        <input matInput="" type="text" formControlName="street" [required]="manualInput" autocomplete="off">
      </mat-form-field>
      <mat-form-field [appearance]="appearance()" [class]="class()" class="basis-1/5">
        <mat-label translate="">House number</mat-label>
        <input matInput="" type="text" formControlName="houseNumber" min="1" [required]="manualInput" autocomplete="off">
      </mat-form-field>
      <mat-form-field [class]="class()" [appearance]="appearance()" class="basis-1/5">
        <mat-label translate="">Addition</mat-label>
        <input matInput="" type="text" formControlName="houseNumberAddition" autocomplete="off">
      </mat-form-field>
    </div>
    <div class="flex gap-[0.75rem]">
      <mat-form-field [appearance]="appearance()" [class]="class()" class="basis-2/5">
        <mat-label translate="">Postalcode</mat-label>
        <input matInput="" type="text" formControlName="postalCode" [maxlength]="manualInput ? 18 : 6" [required]="manualInput" autocomplete="off">
      </mat-form-field>
      <mat-form-field [appearance]="appearance()" [class]="class()" class="basis-2/5">
        <mat-label translate="">City</mat-label>
        <input matInput="" type="text" formControlName="city" [required]="manualInput" autocomplete="off">
      </mat-form-field>
      <unite-country-autocomplete required="" [label]="'Country' | translate" [class]="class()" [appearance]="appearance()" [control]="addressGroup.get('country')" class="basis-1/5">
      </unite-country-autocomplete>
    </div>
  </div>
}

@if (!addressGroup.pristine && !isValidAddress()) {
  <div translate="">
    <span class="pl1 py2 pr2 warning flex justify-start content-center items-center flex-row flex-initial">
      <mat-icon class="icon-small mr1">error_outline</mat-icon>
      <span translate="">This is not a valid address</span>
    </span>
  </div>
}


<!-- </ng-container> -->

<!-- <a class="link mt0" *ngIf="manualInput === false && disableManualEnter == false" (click)="changeManualInput()" translate>Can not find the right the postalcode / house number</a>
<a class="link mt0" *ngIf="manualInput === true" (click)="changeManualInput()" translate>Back to automatically search for addresses</a> -->
